//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const LabResultByID = createAsyncThunk(
  "LabResultByID",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingLabResultByID(""));
      const response = await UsePortalApi(
        `Patient/LabResultByID`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
         dispatch(gettingLabResultByIDSuccess(response)) 
        

      } else {
        dispatch(
          gettingLabResultByIDFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingLabResultByIDFailed(error));
    }
  }
);
const LabResultByIDSlice = createSlice({
  name: "LabResultByID",
  initialState: {
    LabResultByIDData: null,
    isLabResultByIDLoading: false,
    isLabResultByIDError: false,
  },
  reducers: {
    gettingLabResultByID: (state, action) => {
      state.LabResultByIDData = null;
      state.isLabResultByIDLoading = true;
      state.isLabResultByIDError = false;
    },
    gettingLabResultByIDSuccess: (state, action) => {
      state.LabResultByIDData = action.payload;
      state.isLabResultByIDLoading = false;
      state.isLabResultByIDError = false;
    },
    gettingLabResultByIDFailed: (state, action) => {
      state.LabResultByIDData = null;
      state.isLabResultByIDLoading = false;
      state.isLabResultByIDError = true;
    },
    gettingLabResultByIDClear: (state, action) => {
      state.LabResultByIDData = null;
      state.isLabResultByIDLoading = false;
      state.isLabResultByIDError = false;
    },
  },
});
export const {
  gettingLabResultByID,
  gettingLabResultByIDSuccess,
  gettingLabResultByIDFailed,
  gettingLabResultByIDClear,
} = LabResultByIDSlice.actions;
export default LabResultByIDSlice.reducer;
